function onClickSearchMuscles(element) {
	const SEARCH_REDIRECT_URL_PREFIX = '/exercises?exercises_filter[muscle]=';
	var muscle_id = element.dataset.selectedMuscleId;
	if(muscle_id) {
		element.href = SEARCH_REDIRECT_URL_PREFIX + muscle_id;
	}
}

function onClickMuscle(element) {
	const SEARCH_BAR_CONTAINER_ID = 'search_bar_container';
	const SEARCH_BAR_BUTTON_ID = 'search_bar_button';
	const SEARCH_BAR_LINK_ID = 'search_bar_link';
	const SVG_MUSCLE_MAP_ID = 'svg_muscle_map';
	const LOCALE_FRENCH = 'fr';
	const CSS_BLOCK_LEVEL_ELEMENT = 'block';

	var elements_muscle_id = element.dataset.svgMuscleId;
	if(!elements_muscle_id){
		return;
	}

	var muscle_map = {
		"5a5116fdbd649fa94f8b456b" : { "en" : "Hamstrings", "fr" : "Isichio jambier" },
		"5a5116fdbd649fa94f8b456c" : { "en" : "Erector Spinae", "fr" : "Extenseurs du tronc" },
		"5a5116fdbd649fa94f8b456d" : { "en" : "Gluteus maximus", "fr" : "Grand fessier" },
		"5a5116fdbd649fa94f8b456e" : { "en" : "Quadriceps Femoris", "fr" : "Quadriceps" },
		"5a5116fdbd649fa94f8b456f" : { "en" : "Hip Adductors", "fr" : "Adducteurs de la hanche" },
		"5a5116fdbd649fa94f8b4570" : { "en" : "Iliopsoas", "fr" : "Iliopsoas" },
		"5a5116fdbd649fa94f8b4571" : { "en" : "Hip Abductors", "fr" : "Abducteurs de la hanche" },
		"5a5116fdbd649fa94f8b4572" : { "en" : "Triceps Surae", "fr" : "Triceps Surae" },
		"5a5116fdbd649fa94f8b4573" : { "en" : "Ankle Dorsi Flexors", "fr" : "Ankle Dorsi Flexors" },
		"5a5116fdbd649fa94f8b4574" : { "en" : "Pectoralis Major", "fr" : "Pectoralis Major" },
		"5a5116fdbd649fa94f8b4575" : { "en" : "Triceps Brachii", "fr" : "Triceps Brachii" },
		"5a5116fdbd649fa94f8b4576" : { "en" : "Anterior Deltoid", "fr" : "Anterior Deltoid" },
		"5a5116fdbd649fa94f8b4577" : { "en" : "Trapezius", "fr" : "Trapezius" },
		"5a5116fdbd649fa94f8b4578" : { "en" : "Posterior Deltoid", "fr" : "Posterior Deltoid" },
		"5a5116fdbd649fa94f8b4579" : { "en" : "Biceps Brachii", "fr" : "Biceps Brachii" },
		"5a5116fdbd649fa94f8b457a" : { "en" : "Rhomboids", "fr" : "Rhomboids" },
		"5a5116fdbd649fa94f8b457b" : { "en" : "Upper Trapezius", "fr" : "Upper Trapezius" },
		"5a5116fdbd649fa94f8b457c" : { "en" : "Wrist Flexors", "fr" : "Wrist Flexors" },
		"5a5116fdbd649fa94f8b457d" : { "en" : "Wrist Extensors", "fr" : "Wrist Extensors" },
		"5a5116fdbd649fa94f8b457e" : { "en" : "Deltoid", "fr" : "Deltoid" },
		"5a5116fdbd649fa94f8b457f" : { "en" : "Medial Deltoid", "fr" : "Medial Deltoid" },
		"5a5116fdbd649fa94f8b4580" : { "en" : "Supraspinatus", "fr" : "Supraspinatus" },
		"5a5116fdbd649fa94f8b4581" : { "en" : "Pec. Clavicular Head", "fr" : "Pec. Clavicular Head" },
		"5a5116fdbd649fa94f8b4582" : { "en" : "Shoulder External Rotators", "fr" : "Shoulder External Rotators" },
		"5a5116fdbd649fa94f8b4583" : { "en" : "Lower Trapezius", "fr" : "Lower Trapezius" },
		"5a5116fdbd649fa94f8b4584" : { "en" : "Teres Major", "fr" : "Teres Major" },
		"5a5116fdbd649fa94f8b4585" : { "en" : "Serratus Anterior", "fr" : "Serratus Anterior" },
		"5a5116fdbd649fa94f8b4586" : { "en" : "Transversus Abdominis", "fr" : "Transversus Abdominis" },
		"5a5116fdbd649fa94f8b4587" : { "en" : "Rectus Abdominis", "fr" : "Rectus Abdominis" },
		"5a5116fdbd649fa94f8b4588" : { "en" : "Obliques", "fr" : "Obliques" },
		"5a5116fdbd649fa94f8b4589" : { "en" : "Hip Flexors", "fr" : "Hip Flexors" },
		"5a5116fdbd649fa94f8b458a" : { "en" : "Pec. Costal head", "fr" : "Pec. Costal head"},
		"5a5116fdbd649fa94f8b458b" : { "en" : "Pec. Sternal Portion", "fr" : "Pec. Sternal Portion" },
		"5a5116fdbd649fa94f8b458c" : { "en" : "Nec", "fr" : "Nec" },
		"5e45a8080c0d3026c2e9c33d" : { "en" : "Latissimus Dorsi", "fr" : "Latissimus Dorsi" },
		"5e45a8120c0d3026c2e9c33e" : { "en" : "Gluteus medius", "fr" : "Gluteus medius" }
	};

	var search_bar = document.getElementById(SEARCH_BAR_CONTAINER_ID);
	var search_bar_button = document.getElementById(SEARCH_BAR_BUTTON_ID);
	var search_bar_link = document.getElementById(SEARCH_BAR_LINK_ID);
	var svg_muscle_map_element = document.getElementById(SVG_MUSCLE_MAP_ID);
	var locale = svg_muscle_map_element.dataset.muscleMapLocale;
	var muscle_name = '';

	if(locale === LOCALE_FRENCH) {
		muscle_name = muscle_map[element.dataset.svgMuscleId].fr;
	} else {
		muscle_name = muscle_map[element.dataset.svgMuscleId].en;
	}

	if(!search_bar || !search_bar_button || !search_bar_link){
		return;
	}
	search_bar.style.display = CSS_BLOCK_LEVEL_ELEMENT;
	search_bar_button.innerHTML = muscle_name;
	search_bar_link.dataset.selectedMuscleId = element.dataset.svgMuscleId;
}

function onHoverMuscle(element){
	const CLASS_FLAG_HIGHLIGHTED = 'highlighted';
	const CSS_ON_HOVER_COLOR = '#686868';
	const CSS_ON_HOVER_STROKE_WIDTH = '1.4866';
	const CSS_ON_HOVER_STROKE = '#474746';

	var elements_muscle_id = element.dataset.svgMuscleId;
	if(!elements_muscle_id){
		return;
	}

    if(element.classList.contains(CLASS_FLAG_HIGHLIGHTED) === false) {
		element.style.fill = CSS_ON_HOVER_COLOR;
		element.style.strokeWidth = CSS_ON_HOVER_STROKE_WIDTH;
		element.style.stroke = CSS_ON_HOVER_STROKE;
    }
}

function unHoverMuscle(element){
	const CLASS_FLAG_HIGHLIGHTED = 'highlighted';
	const CSS_ON_HOVER_COLOR = '#A0A0A0';
	const CSS_ON_HOVER_STROKE_WIDTH = '1.4866';
	const CSS_ON_HOVER_STROKE = '#474746';

	var elements_muscle_id = element.dataset.svgMuscleId;
	if(!elements_muscle_id){
		return;
	}

    if(element.classList.contains(CLASS_FLAG_HIGHLIGHTED) === false) {
		element.style.fill = CSS_ON_HOVER_COLOR;
		element.style.strokeWidth = CSS_ON_HOVER_STROKE_WIDTH;
		element.style.stroke = CSS_ON_HOVER_STROKE;
    }
}

function initMuscleMap() {
    const EXERCISE_DETAILS_LIST_MUSCLE_ID_ATTR = "[data-exercise-details-list-muscle-id]";
    //retrievel of the muscle data from DOM.
    var muscles_from_execise_detail = $(EXERCISE_DETAILS_LIST_MUSCLE_ID_ATTR);
    if(muscles_from_execise_detail) {
        highlight_muscles_accordingly(muscles_from_execise_detail);
    } else {
        return;
    }

    /*
        This function will take care of the highlightening of the muscles given a muscle array.
    */
    function highlight_muscles_accordingly(muscles_from_execise_detail) {
        const SVG_MUSCLE_ID_ATTR_PREFIX = "[data-svg-muscle-id='";
        const SVG_MUSCLE_ID_ATTR_POSTIFX = "']";
        const CSS_BLOCK_LEVEL_ELEMENT = 'block';
        const CLASS_FLAG_HIGHLIGHTED = 'highlighted';
        const CSS_ON_HOVER_COLOR = '#C4D334';
        const CSS_ON_HOVER_STROKE_WIDTH = '1.4866';
        const CSS_ON_HOVER_STROKE = '#474746';

        let muscle_array_lenght = muscles_from_execise_detail.length;
        for(var k = 0 ; k < muscle_array_lenght ; k++) {
            let muscle_id = muscles_from_execise_detail[k].dataset.exerciseDetailsListMuscleId;
            var muscle_svg_element = $(SVG_MUSCLE_ID_ATTR_PREFIX + muscle_id + SVG_MUSCLE_ID_ATTR_POSTIFX);
            if(muscle_svg_element.length === 1) {
                muscle_svg_element[0].style.display = CSS_BLOCK_LEVEL_ELEMENT;
                muscle_svg_element[0].style.fill = CSS_ON_HOVER_COLOR;
                muscle_svg_element[0].style.strokeWidth = CSS_ON_HOVER_STROKE_WIDTH;
                muscle_svg_element[0].style.stroke = CSS_ON_HOVER_STROKE;
                muscle_svg_element[0].classList.add(CLASS_FLAG_HIGHLIGHTED);
            }
        }
    }
}
$(document).ready(initMuscleMap);
